import { useEffect, useRef, useState } from "react";
import './MultiSelect.css';
import { FaTimes } from "react-icons/fa";
import { generatePastelHexColor } from "../../utils/color";
import { removeSpecialChars } from "../../utils/string";

function MultiSelect(props) {
	const [options, setOptions] = useState(props.options ?? []);
	const [search, setSearch] = useState('');
	const [selectedOptions, setSelectedOptions] = useState(props.values ?? []);
	const [generatedColors, setGeneratedColors] = useState({});
	const [isFocused, setIsFocused] = useState(false);
	const [isOptionsOpen, setIsOptionsOpen] = useState(false);
	const ref = useRef();
	const inputRef = useRef();

	useEffect(() => {
		setOptions(props.options ?? []);
	}, [props.options]);

	useEffect(() => {
		setSelectedOptions(props.values ?? []);
		const newGenerateColors = {};
		const currentGeneratedColors = generatedColors;
		Object.keys(currentGeneratedColors).forEach(value => {
			if (!props.values.includes(value)) {
				delete currentGeneratedColors[value];
			}
		});
		props.values?.forEach(value => {
			newGenerateColors[value] = generatePastelHexColor({ minLightness: 70, maxLightness: 80 });
		});
		setGeneratedColors({
			...newGenerateColors,
			...currentGeneratedColors,
		});
	}, [props.values]);

	function onFocus(e) {
		setIsFocused(true);
		setIsOptionsOpen(true);
	}

	useEffect(() => {
		function onGlobalClick(e) {
			if (!ref.current?.contains(e.target)) {
				setIsOptionsOpen(false);
			}
		}
		document.addEventListener('click', onGlobalClick);
		return () => document.removeEventListener('click', onGlobalClick);
	}, []);

	function onClick(e) {
		if (!isFocused) inputRef.current.focus();
	}

	function onItemClick(value) {
		setGeneratedColors(generatedColors => {
			const _new = generatedColors;
			_new[value] = generatePastelHexColor({ minLightness: 70, maxLightness: 80 });
			return { ..._new };
		});
		const set = new Set(selectedOptions);
		set.add(value);
		const newState = [...Array.from(set)];
		setSelectedOptions(newState);
		if (props.onChange) props.onChange(newState);
	}

	function removeItem(value) {
		const newState = [...selectedOptions.filter(selectedOption => selectedOption !== value)];
		setSelectedOptions(newState);
		setGeneratedColors(generatedColors => {
			delete generatedColors[value];
			return { ...generatedColors };
		});
		if (props.onChange) props.onChange(newState);
	}

	function removeLastItem() {
		const lastItem = selectedOptions[selectedOptions.length - 1];
		removeItem(lastItem);
	}

	function onSearch(e) {
		setSearch(e.target.value);
	}

	function onSearhKeyUp(e) {
		if (e.keyCode === 8 && e.target.value.length === 0) {
			removeLastItem();
		}
	}

	const filteredOptions = options.filter(option => !selectedOptions.includes(option.value) && (!search || (search && removeSpecialChars(option.text.toLowerCase()).indexOf(removeSpecialChars(search.toLowerCase())) !== -1)));

	return (
		<div ref={ref} className={`multi-select ${isFocused && 'is-focused'}`} onClick={onClick}>
			<label className="input-label">Perfis</label>
			<div className="control-area">
				{selectedOptions && selectedOptions.length > 0 ? (
					<>
						{
							selectedOptions.map(selectedOption => (
								<span className="selected-option" style={{ '--option-color': generatedColors[selectedOption] }}>
									<small>
										{options.find(option => option.value === selectedOption)?.text}
									</small>
									<button type="button" onClick={(e) => removeItem(selectedOption)}>
										<FaTimes />
									</button>
								</span>
							))
						}
					</>
				) : (
					!isFocused && <p className="empty-options">Nenhum item selecionado</p>
				)}
				<input ref={inputRef} value={search ?? ''} onChange={(e) => onSearch(e)} onKeyUp={(e) => onSearhKeyUp(e)} onBlur={(e) => setIsFocused(false)} onFocus={onFocus} />
			</div>
			{isOptionsOpen && filteredOptions.length > 0 && (
				<ul>
					{filteredOptions.map(option => (
						<li>
							<button type="button" onClick={(e) => onItemClick(option.value)}>{option.text}</button>
						</li>
					))}
				</ul>
			)}
		</div>
	);
}

export default MultiSelect;